import React from 'react';
import {Row, Col} from 'react-bootstrap';
import {useSearchParams} from 'react-router-dom';

export default function BargraphResponse({
  label,
  numOfCol,
  subquestionNumber,
  questionResponse,
  subKeys,
}) {
 
  const totalColumns = [];
  if (numOfCol) {
    for (let i = 1; i <= numOfCol; i++) {
      totalColumns.push(i);
    }
  }

  const [params] = useSearchParams();
  const debug_prm = params.get('debug');

  let totalQuesWeight = [];
  questionResponse?.forEach(res => totalQuesWeight.push(parseFloat(res.weight)));
  
  // console.log(subquestionNumber);
  return (
    <Row className="pt-3 pb-2 border-bottom-result">
      <u className="question-label">{label}</u>
      {totalColumns.map((col, idx) => {
        var filteredResponse = questionResponse;
        // console.log(filteredResponse);
        // console.log(col);

        let responseDegree;
        if (subquestionNumber) {
          responseDegree = filteredResponse?.filter(
            ques => ques.response[subquestionNumber] === col
          );
        } else {
         
         responseDegree = filteredResponse?.filter(ques => ques.response[subKeys[0]] === col);
                 
        }
        // console.log(responseDegree);

        let resTotalWeight = [];

        responseDegree?.forEach(res => resTotalWeight.push(parseFloat(res.weight)));
        
        const totalResponseCount = totalQuesWeight.reduce((prev, curr) => prev + curr, 0);
        const responseCount = resTotalWeight.reduce((prev, curr) => prev + curr, 0);

     

        const fixedPercent= (responseCount / totalResponseCount) * 100;
        // const percent = fixedPercent.toFixed(2);
        const percent = Math.round((responseCount / totalResponseCount) * 100);
       
        
        return (
          <Col key={idx} className="bargraph-container text-center">
            <div className="bargraph position-relative">
              <div
                className="gradient position-absolute fixed-bottom"
                style={{height: `${percent > 0 ? percent+3 : 0}%`}}
              ></div>
            </div>
            {percent > 0 ? `${percent}%` : '---'}
            <br />
            {debug_prm && (
              <>
                <div>{responseCount}</div>
                <div>{(responseCount / totalResponseCount) * 100}</div>
              </>
            )}
          </Col>
        );
      })}
    </Row>
  );
}
